import React, { useEffect, useState } from 'react';
import CultService from '../Services/CultService';
import { useSelector } from 'react-redux';
import { HelperTexts } from '../Utils/helper/HelperTexts';
import toast from 'react-hot-toast';
import { Select } from 'antd';
import { AppColors } from '../Utils/helper/AppColors';
import { SearchIcon } from './Icons/Icons';
import { getColorSettings } from '../Utils/helper/commonUtils';

export default function SelectCampaign({ handleSelectCampaign, width, color, bgColor, noCustomClass = false }) {
	const company = useSelector((state) => state?.app?.company);
	const [campaigns, setCampaigns] = useState([]);

	const getCampaings = async () => {
		try {
			// let res = await CultService.getCampaignList({ params: { companyId: company?._id } });
			let res = await CultService.getCampaignBasicDetails({ params: { companyId: company?._id, status: ['live', 'completed'] } });
			if (res.status == 200) {
				// setCampaigns(res?.data);
				setCampaigns(res?.data?.data);
				console.log('okk-->>', res?.data);
			}
		} catch (err) {
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
		}
	};

	useEffect(() => {
		if (company) {
			getCampaings();
		}
	}, [company]);

	const localSettingColors = getColorSettings();

	return (
		<Select
			// className={!noCustomClass ? 'custom-select' : undefined}
			onChange={handleSelectCampaign}
			style={{
				width: width || '50%',
				background: AppColors.lightest_grey || localSettingColors.quinary,
				color: AppColors.midnight_black || color || localSettingColors.fontColor,
				borderRadius: 8,
				fontFamily: 'Poppins, sans-serif',
			}}
			dropdownStyle={{
				backgroundColor: AppColors.lightest_grey || bgColor || localSettingColors.quinary,
				color: AppColors.midnight_black || color || localSettingColors.fontColor,
				borderRadius: 8,
				fontFamily: 'Poppins, sans-serif',
			}}
			showSearch
			placeholder={<span style={{ color: AppColors.midnight_black || color || localSettingColors.fontColor }}>Select a Campaign</span>}
			suffixIcon={<SearchIcon color={ AppColors.midnight_black || color || localSettingColors.fontColor} size={18} />}
			filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
			getPopupContainer={(triggerNode) => triggerNode.parentNode} // used when we are on models...
		>
			{campaigns.map((option) => (
				<Select.Option
					// key={option._id} value={option._id} item={option}>
					// 	{option?.basicDetails?.name}
					// </Select.Option>
					// <Select.Option
					key={option._id}
					value={option._id}
					item={option}
					style={{
						color: AppColors.midnight_black || color || localSettingColors.fontColor,
						background: AppColors.lightest_grey || bgColor || localSettingColors.quinary,
						fontFamily: 'Poppins, sans-serif',
					}}
				>
					{option?.basicDetails?.name}
				</Select.Option>
			))}
		</Select>
	);
}
